<template>
  <div id="carousel" class="section">
    <div class="container">
      <div class="title text-center">
        <h4>{{ header }}</h4>
      </div>
      <div v-if="carousel" class="row justify-content-center">
        <div class="col-12">
          <el-carousel height="600px" indicator-position="outside">
            <el-carousel-item v-for="image in carousel" :key="image.fileName">
              <img :alt="image.description" :src="image.url" class="d-block"/>
              <div class="carousel-caption d-none d-md-block">
                <h5>{{ image.description }}</h5>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Carousel, CarouselItem} from 'element-ui';
import {createContentfulClient} from "@/api/ContentfulClient";

const client = createContentfulClient();

export default {
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  data() {
    return {
      header: undefined,
      carousel: undefined
    }

  },
  created() {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData() {
      this.error = this.post = null;
      this.loading = true;
      const entries = await client.getEntries({
        'content_type': 'carousel',
        'fields.slug': process.env.VUE_APP_CARROUSEL,
        'include': 3
      });

      if (entries.total >= 1) {
        this.header = entries.items[0].fields.header;
        this.carousel = entries.items[0].fields.images.map(image => {
          return {
            description: image.fields.description,
            url: image.fields.file.url,
            fileName: image.fields.file.fileName
          }
        });
      } else if (entries.errors) {
        this.$router.push('/')
      }
    }
  }

};
</script>
<style lang="scss" scoped>
.el-carousel {
  .carousel-caption {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 5px;

    h5 {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

}
</style>
